import { useEffect, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { BookOpen, Home } from "lucide-react";
import Api from "../../../shared/api/api";
import "../styles/AlreadyDownloadedPage.css";

export default function AlreadyDownloadedPage() {
  const [params] = useSearchParams();
  const notice = params.get("notice");
  const [valid, setValid] = useState(null);
  useEffect(() => {
    let active = true;
    if (!notice) { setValid(false); return () => { active = false; }; }
    setValid(null);
    Api.getReaderDownloadNotice(notice).then(result => { if (active) setValid(result.already_used === true); }).catch(() => { if (active) setValid(false); });
    return () => { active = false; };
  }, [notice]);
  if (valid === false) return <Navigate to="/" replace />;
  return <main className="reader-download-notice">
    {valid === null ? <p role="status">Checking your download link...</p> : <>
      <BookOpen size={36} aria-hidden="true" />
      <h1>Your Download Link Has Already Been Used</h1>
      <p>Your <em>Dawn of Prophecy</em> link can be used only once. The ebook has already been requested, or the first download is still in progress.</p>
      <p>Check your downloads folder for your copy. This attempt hasn't downloaded another file.</p>
      <p>If the first download didn't finish, please <Link to="/contact">contact me</Link> for help.</p>
      <Link className="reader-download-home" to="/"><Home size={18} />Back to home</Link>
    </>}
  </main>;
}
